/*
  WHIFF V2 | ostoskoripaneelin toiminnot

  Ladataan snippets/whiff-cart-drawer.liquid -tiedostosta. Suoritetaan vain kerran (window.WhiffCart).
  Kaikki rakenne tulee Liquidista. Tama tiedosto vain toimii sen paalla:

  0. Nopea paneeli: Kingin cart-drawer.renderContents() korvataan versiolla, joka tekee saman
     tyon ilman Kingin viiveita (1,2 s + 0,4 s + 0,6 s). Paneeli aukeaa heti, kun Shopify vastaa.
     Kingin tiedostoa (assets/theme.js) ei muuteta: alkuperainen metodi jaa talteen nimella
     _whiffOriginalRender ja sita kaytetaan, jos jokin menee pieleen.
  1. Koon nosto 5 ml -> 10 ml: yksi /cart/update.js -kutsu ja paneelin paivitys samalla metodilla.
  2. Suosittelut: naytettavat rivit valitaan seuraavan edun mukaan (whiff-core.js:n laskema tila).
  3. Ilmainen 2 ml (gift_mode 'line'):
       - oikea 2 ml rivi ominaisuudella _whiff_gift; Shopifyn automaattinen Buy X get Y -alennus
         tekee siita 0 euroa (ei selaimessa laskettua hintaa)
       - valintakortit suoraan korin ylalaidassa ([data-whiff-gift-inline], whiff-cart-gift part 'inline'):
         naytetaan, kun raja on ylittynyt eika lahjaa ole valittu. "Vaihda" avaa ne uudelleen.
       - (vanha tapa ilman kortteja: valintapaneeli haetaan laiskasti sections/whiff-gift-picker.liquid)
       - rivi poistetaan, jos summa putoaa alle rajan tai Shopify ei alentanut sita (hinta > 0);
         maara pidetaan 1:ssa
     'preview' ja 'attribute' toimivat kuten ennen (cart attribute).

  Ei omaa ostoskorilogiikkaa: Shopifyn ostoskori ja Kingin lomakkeet ovat ainoa totuus.
*/
(function () {
  if (window.WhiffCart) return;
  window.WhiffCart = { version: '11' };

  var GIFT_ATTR = '_whiff_gift';
  var GIFT_LABEL_ATTR = '2 ml lahja';
  var PROMPT_KEY = 'whiff_gift_prompted';

  function drawer() {
    return document.querySelector('cart-drawer');
  }
  function routes() {
    return window.routes || {};
  }
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function sectionId() {
    var el = document.querySelector('[cart-drawer-section]');
    return el ? el.dataset.id : 'cart-drawer';
  }
  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) throw json;
        return json;
      });
    });
  }
  /* Paneelin paivitys Kingin omalla metodilla (sama kuin tuotesivun Add to Cart) */
  /* silent = true: korjaus taustalla (esim. lahjan vartija sivun latautuessa). Sisalto paivittyy,
     mutta suljettua paneelia ei avata. */
  var silentRender = false;
  function applyCart(json, silent) {
    var cart = drawer();
    if (cart && typeof cart.renderContents === 'function' && json && json.sections) {
      silentRender = !!silent;
      try {
        cart.renderContents(json);
      } finally {
        silentRender = false;
      }
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'whiff-cart', cartData: json });
      }
    } catch (error) { /* pubsub puuttuu */ }
  }
  /* Kirjoitettu lahjaviesti ja lisatieto mukaan samaan kutsuun, jotta mitaan ei katoa */
  function pendingText(body) {
    var note = document.getElementById('cart-drawer-note');
    var gift = document.getElementById('WhiffCartGift');
    if (note) body.note = note.value;
    if (gift) {
      body.attributes = body.attributes || {};
      body.attributes.gift_message = gift.value;
    }
    return body;
  }
  function withSections(body) {
    body.sections = [sectionId()];
    body.sections_url = window.location.pathname;
    return body;
  }
  function updateUrl() {
    return (routes().cart_update_url || '/cart/update') + '.js';
  }
  function changeUrl() {
    return (routes().cart_change_url || '/cart/change') + '.js';
  }
  function addUrl() {
    return (routes().cart_add_url || '/cart/add') + '.js';
  }
  function session(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (error) { /* yksityinen selaus */ }
    return null;
  }

  /* ---------- 0. Nopea paneeli ilman Kingin viiveita ---------- */

  function updateCount(part) {
    var source = part.querySelector('[data-cart-items]');
    var badge = document.querySelector('[data-cart-count]');
    if (!source || !badge) return;
    var items = source.dataset.cartItems;
    if (items == 0 || items === '') {
      badge.classList.add('hidden');
      badge.textContent = '';
    } else if (parseInt(items, 10) > 99) {
      badge.classList.remove('hidden');
      badge.classList.add('large-items');
      badge.textContent = '';
    } else {
      badge.classList.remove('hidden', 'large-items');
      badge.textContent = items;
    }
  }

  /* Sama tyo kuin Kingin renderContents: sisalto, korilaskuri, Kingin toimituspalkki,
     painikkeiden kuuntelijat ja paneelin avaus. Erona vain, etta HTML jasennetaan kerran
     ja paneeli aukeaa heti eika 1,2 sekunnin paasta. */
  function fastRender(parsedState) {
    var self = this;
    var body = this.querySelector('[data-cart-drawer-body]');
    if (body) body.classList.remove('is-empty');
    this.productId = parsedState.id;

    var sections = this.getSectionsToRender();
    var parts = sections.map(function (section) {
      var html = parsedState.sections && parsedState.sections[section.section];
      if (!html) throw new Error('section missing');
      var part = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!part) throw new Error('selector missing');
      return part;
    });

    sections.forEach(function (section, index) {
      var part = parts[index];
      var host = document.getElementById(section.id);
      var target = host.querySelector(section.selector) || host;
      target.innerHTML = part.innerHTML;
      updateCount(part);
      if (part.querySelector('[data-cart-shipping]') && typeof shippingconversion === 'function') {
        window.requestAnimationFrame(function () { shippingconversion(); });
      }
      self.setUpCartButtonListeners();
    });

    var panel = document.querySelector('[cart-drawer-section]');
    if (!panel) return;
    if (silentRender && !panel.classList.contains('show')) return;
    /* Kingin oma siivous paneelin sisalla oleville toissijaisille laatikoille */
    window.requestAnimationFrame(function () {
      var inner = self.querySelector('[data-drawer]');
      if (inner) {
        inner.classList.remove('show');
        window.setTimeout(function () { inner.style.display = 'none'; }, 1000);
      }
    });
    var wasOpen = panel.classList.contains('show');
    panel.style.display = 'flex';
    this.open();
    if (wasOpen) return;
    /* Pakotettu asettelu, jotta liukuanimaatio lahtee display:none-tilasta */
    void panel.offsetWidth;
    window.requestAnimationFrame(function () {
      panel.classList.add('show', 'shadow');
      document.body.classList.add('overflow-hidden');
    });
  }

  function patchDrawer() {
    var Drawer = window.customElements && window.customElements.get('cart-drawer');
    if (!Drawer || Drawer.prototype._whiffFast) return;
    var proto = Drawer.prototype;
    var original = proto.renderContents;
    if (typeof original !== 'function') return;
    proto._whiffOriginalRender = original;
    proto._whiffFast = true;
    proto.renderContents = function (parsedState) {
      try {
        fastRender.call(this, parsedState);
      } catch (error) {
        original.call(this, parsedState);
      }
    };
  }
  if (window.customElements) {
    patchDrawer();
    window.customElements.whenDefined('cart-drawer').then(patchDrawer);
  }

  /* ---------- 1. Koon nosto 5 ml -> 10 ml ---------- */

  function upgrade(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    var updates = {};
    updates[button.dataset.key] = 0;
    updates[button.dataset.to] = parseInt(button.dataset.qty, 10) || 1;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    jsonPost(updateUrl(), withSections(pendingText({ updates: updates })))
      .then(applyCart)
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        var row = button.closest('.whiff-cart-item');
        var error = row && row.querySelector('.whiff-cart-item__error');
        if (error) {
          error.textContent = button.dataset.error || '';
          error.classList.remove('hidden');
        }
      });
  }

  /* ---------- 2. Suosittelut seuraavan edun mukaan ---------- */

  function rankRecs(box) {
    var root = drawer();
    var recs = root && root.querySelector('[data-whiff-recs]');
    if (!recs) return;
    var rows = Array.prototype.slice.call(recs.querySelectorAll('[data-whiff-rec]'));
    var remaining = box ? parseInt(box.dataset.remaining, 10) || 0 : 0;
    var stage = box ? box.dataset.stage : 'none';

    var ordered = rows.slice();
    if (remaining > 0) {
      /* Ensin halvin, joka kattaa puuttuvan summan, sitten muut Liquidin jarjestyksessa */
      var covering = rows.filter(function (r) { return parseInt(r.dataset.price, 10) >= remaining; })
        .sort(function (a, b) { return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10); });
      var rest = rows.filter(function (r) { return covering.indexOf(r) === -1; });
      ordered = covering.slice(0, 1).concat(rest, covering.slice(1));
    }
    var list = recs.querySelector('.whiff-cart-recs__list');
    ordered.forEach(function (row, index) {
      row.dataset.rank = String(index + 1);
      row.hidden = index >= 3;
      if (list && row.parentNode === list) list.appendChild(row);
    });

    var hint = recs.querySelector('[data-whiff-recs-hint]');
    if (hint) {
      var text = '';
      if (stage === 'ship') text = hint.dataset.textShip;
      if (stage === 'sample') text = hint.dataset.textSample;
      hint.textContent = text ? text.replace('[amount]', box.dataset.remainingMoney || '') : '';
      hint.hidden = !text;
    }
  }

  /* ---------- 3. 2 ml lahja ---------- */

  function giftMode() {
    var root = drawer();
    return root ? (root.dataset.giftMode || 'off') : 'off';
  }
  function previewFlag() {
    try {
      var match = /[?&]whiff_gift=(preview|off)\b/.exec(window.location.search);
      if (match) {
        if (match[1] === 'preview') window.sessionStorage.setItem('whiff_gift_preview', '1');
        else window.sessionStorage.removeItem('whiff_gift_preview');
      }
      return window.sessionStorage.getItem('whiff_gift_preview') === '1';
    } catch (error) {
      return /[?&]whiff_gift=preview\b/.test(window.location.search);
    }
  }
  function giftEnabled() {
    var mode = giftMode();
    if (mode === 'attribute' || mode === 'line') return true;
    if (mode !== 'preview') return false;
    var root = drawer();
    return !!(root && root.dataset.designMode === 'true') || previewFlag();
  }

  var adapters = {
    /* Valinta tallennetaan tilaukselle cart attributena. Summaan ei lisata mitaan. */
    attribute: {
      select: function (option) {
        var attributes = {};
        attributes[GIFT_ATTR] = option.handle + '|' + option.variant;
        attributes[GIFT_LABEL_ATTR] = option.label;
        return jsonPost(updateUrl(), withSections(pendingText({ attributes: attributes })));
      },
      clear: function () {
        var attributes = {};
        attributes[GIFT_ATTR] = '';
        attributes[GIFT_LABEL_ATTR] = '';
        return jsonPost(updateUrl(), withSections(pendingText({ attributes: attributes })));
      }
    },
    /* Oikea 2 ml rivi. Shopifyn automaattinen Buy X get Y -alennus tekee siita 0 euroa.
       Vanha lahjarivi poistetaan ensin, joten korissa on aina enintaan yksi lahja. */
    line: {
      select: function (option, currentKey) {
        var remove = currentKey
          ? jsonPost(changeUrl(), { id: currentKey, quantity: 0 })
          : Promise.resolve();
        return remove.then(function () {
          return jsonPost(addUrl(), withSections({
            items: [{ id: parseInt(option.variant, 10), quantity: 1, properties: { _whiff_gift: '1' } }]
          }));
        });
      },
      clear: function (currentKey) {
        if (!currentKey) return Promise.resolve(null);
        return jsonPost(changeUrl(), withSections({ id: currentKey, quantity: 0 }));
      },
      quantity: function (currentKey, qty) {
        return jsonPost(changeUrl(), withSections({ id: currentKey, quantity: qty }));
      }
    }
  };
  adapters.preview = adapters.attribute;

  /* Laiska valintapaneeli: haetaan kerran sivua kohden, kun raja on saavutettu */
  var pickerHtml = null;
  var pickerRequest = null;
  function giftMount() {
    var root = drawer();
    return root && root.querySelector('[data-whiff-gift-mount]');
  }
  function fetchPicker() {
    if (pickerHtml !== null) return Promise.resolve(pickerHtml);
    if (pickerRequest) return pickerRequest;
    var mount = giftMount();
    var section = (mount && mount.dataset.section) || 'whiff-gift-picker';
    pickerRequest = fetch(rootUrl() + '?section_id=' + encodeURIComponent(section), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('picker');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sheet = doc.querySelector('[data-whiff-gift-sheet]');
        pickerHtml = sheet ? sheet.outerHTML : '';
        pickerRequest = null;
        return pickerHtml;
      })
      .catch(function (error) {
        pickerRequest = null;
        throw error;
      });
    return pickerRequest;
  }
  function currentGiftVariant() {
    var root = drawer();
    var line = root && root.querySelector('[data-whiff-gift-line]');
    return line ? line.dataset.giftVariant : '';
  }
  /* Valittu vaihtoehto merkitaan nykyisen lahjarivin mukaan, joten valimuistissa oleva paneeli pysyy oikeana */
  function markSelected(sheet) {
    var mount = giftMount();
    var chosen = currentGiftVariant();
    sheet.querySelectorAll('[data-whiff-gift-choose]').forEach(function (button) {
      var on = !!chosen && button.dataset.variant === chosen;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.removeAttribute('aria-busy');
      var label = button.querySelector('[data-whiff-gift-choose-label]');
      if (mount && label) label.textContent = on ? mount.dataset.textChosen : mount.dataset.textChoose;
      else if (mount) button.textContent = on ? mount.dataset.textChosen : mount.dataset.textChoose;
      var option = button.closest('.whiff-gift-option, .whiff-gift-pick__item');
      if (option) option.classList.toggle('is-selected', on);
    });
  }
  function ensureSheet() {
    var mount = giftMount();
    if (!mount) return Promise.resolve(null);
    var existing = mount.querySelector('[data-whiff-gift-sheet]');
    if (existing) return Promise.resolve(existing);
    return fetchPicker().then(function (html) {
      var target = giftMount();
      if (!target || !html) return null;
      var holder = target.querySelector('[data-whiff-gift-sheet]');
      if (!holder) {
        target.innerHTML = html;
        holder = target.querySelector('[data-whiff-gift-sheet]');
      }
      return holder;
    });
  }
  function giftSheet() {
    var root = drawer();
    return root && root.querySelector('[data-whiff-gift-sheet]');
  }
  /* Valintakortit korissa (marraskuu 2026). Kun ne ovat paneelissa, niita kaytetaan paneelin sijaan. */
  function giftInline() {
    var root = drawer();
    return root && root.querySelector('[data-whiff-gift-inline]');
  }
  var inlineChanging = false;

  var lastFocus = null;
  function openGift(trigger) {
    if (!giftEnabled()) return;
    var inline = giftInline();
    if (inline) {
      inlineChanging = true;
      markSelected(inline);
      var inlineError = inline.querySelector('[data-whiff-gift-error]');
      if (inlineError) inlineError.hidden = true;
      var closer = inline.querySelector('[data-whiff-gift-close]');
      if (closer) closer.hidden = !currentGiftVariant();
      inline.hidden = false;
      try { inline.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (error) { inline.scrollIntoView(); }
      var firstCard = inline.querySelector('[data-whiff-gift-choose]');
      if (firstCard) firstCard.focus({ preventScroll: true });
      return;
    }
    lastFocus = trigger || document.activeElement;
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    ensureSheet().then(function (sheet) {
      if (trigger) trigger.removeAttribute('aria-busy');
      if (!sheet) return;
      markSelected(sheet);
      var error = sheet.querySelector('[data-whiff-gift-error]');
      if (error) error.hidden = true;
      sheet.hidden = false;
      window.requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      var first = sheet.querySelector('.whiff-gift-option__choose, [data-whiff-gift-close]');
      if (first) first.focus();
    }).catch(function () {
      if (trigger) trigger.removeAttribute('aria-busy');
    });
  }
  function closeGift() {
    var inline = giftInline();
    if (inline && inlineChanging) {
      inlineChanging = false;
      if (currentGiftVariant()) inline.hidden = true;
      var changeButton = drawer().querySelector('[data-whiff-gift-line] [data-whiff-gift-open]');
      if (changeButton) changeButton.focus();
      return;
    }
    var sheet = giftSheet();
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    window.setTimeout(function () { sheet.hidden = true; }, 250);
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
  }

  /* Viesti lahjarivin kohdalle seuraavan renderoinnin jalkeen (esim. "lahja poistettiin") */
  var pendingNote = '';
  function showNote() {
    var root = drawer();
    var note = root && root.querySelector('[data-whiff-gift-note]');
    if (!note) return;
    note.textContent = pendingNote;
    note.hidden = !pendingNote;
    pendingNote = '';
  }

  function chooseGift(button) {
    var mode = giftMode();
    var adapter = adapters[mode];
    if (!adapter || button.getAttribute('aria-busy') === 'true') return;
    var line = drawer().querySelector('[data-whiff-gift-line]');
    if (mode === 'line' && line && line.dataset.giftVariant === button.dataset.variant) {
      closeGift();
      return;
    }
    button.setAttribute('aria-busy', 'true');
    adapter.select({ variant: button.dataset.variant, handle: button.dataset.handle, label: button.dataset.label }, line ? line.dataset.giftKey : '')
      .then(function (json) {
        /* Valinta tehty: kortit piiloon ennen kuin paneeli renderoidaan uudelleen */
        inlineChanging = false;
        if (json) applyCart(json);
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        var holder = giftInline() || giftSheet();
        var error = holder && holder.querySelector('[data-whiff-gift-error]');
        if (error) error.hidden = false;
      });
  }

  /* Paneeli on auki tai aukeamassa (Kingin display:flex asetetaan ennen show-luokkaa) */
  function panelOpen() {
    var panel = document.querySelector('[cart-drawer-section]');
    return !!panel && (panel.classList.contains('show') || panel.style.display === 'flex');
  }
  /* Kun raja on saavutettu ja paneeli on auki: valintapaneeli haetaan taustalla valmiiksi,
     ja se avataan itsestaan kerran istunnossa. Sen jalkeen CTA jaa nakyviin. */
  function maybePrompt(root) {
    if (!panelOpen()) return;
    fetchPicker().catch(function () { /* CTA hakee uudelleen */ });
    if (session(PROMPT_KEY) === '1') return;
    window.clearTimeout(promptTimer);
    promptTimer = window.setTimeout(function () {
      var panel = document.querySelector('[cart-drawer-section]');
      var liveCta = root.querySelector('[data-whiff-gift-cta]');
      if (!panel || !panel.classList.contains('show') || !liveCta || liveCta.hidden) return;
      if (root.querySelector('[data-whiff-gift-line]') || session(PROMPT_KEY) === '1') return;
      if (giftSheet() && !giftSheet().hidden) return;
      session(PROMPT_KEY, '1');
      openGift(liveCta);
    }, 550);
  }

  /* Lahjan tila etupalkin mukaan. Kutsutaan aina, kun paneelin Liquid on renderoitu uudelleen. */
  var guarding = false;
  var promptTimer = null;
  function syncGift(box) {
    var root = drawer();
    if (!root) return;
    var enabled = giftEnabled();
    var mode = giftMode();
    var reached = !!box && box.dataset.sampleReached === 'true';
    var line = root.querySelector('[data-whiff-gift-line]');
    var cta = root.querySelector('[data-whiff-gift-cta]');
    var mount = giftMount();

    if (mode === 'line') {
      var inline = giftInline();
      if (cta) cta.hidden = !!inline || !(enabled && reached && !line);
      if (inline) {
        /* Kortit: raja ylitetty eika lahjaa valittu, tai asiakas painoi "Vaihda" */
        if (!line) inlineChanging = false;
        inline.hidden = !(enabled && reached && (!line || inlineChanging));
        var closeButton = inline.querySelector('[data-whiff-gift-close]');
        if (closeButton) closeButton.hidden = !line;
        markSelected(inline);
      }
      showNote();
      if (!enabled || guarding) return;

      /* Vartija: lahja vain, kun raja on saavutettu ja Shopify on alentanut sen. Maara aina 1. */
      if (line && box && (!reached || line.dataset.giftPaid === 'true')) {
        guarding = true;
        pendingNote = mount ? (reached ? mount.dataset.textUnavailable : mount.dataset.textRemoved) : '';
        adapters.line.clear(line.dataset.giftKey)
          .then(function (json) { guarding = false; if (json) applyCart(json, true); })
          .catch(function () { guarding = false; pendingNote = ''; });
        return;
      }
      if (line && (parseInt(line.dataset.giftQty, 10) || 1) > 1) {
        guarding = true;
        adapters.line.quantity(line.dataset.giftKey, 1)
          .then(function (json) { guarding = false; if (json) applyCart(json, true); })
          .catch(function () { guarding = false; });
        return;
      }

      if (reached && cta && !line && !inline) maybePrompt(root);
      return;
    }

    /* 'preview' ja 'attribute' */
    if (line) line.hidden = !enabled || !reached;
    if (cta) cta.hidden = !(enabled && reached && !line);
    if (enabled && box && !reached && line && !guarding) {
      guarding = true;
      adapters.attribute.clear().then(function (json) { guarding = false; if (json) applyCart(json, true); })
        .catch(function () { guarding = false; });
    }
  }

  /* ---------- Tapahtumat (rekisteroidaan kerran) ---------- */

  document.addEventListener('whiff:offers', function (event) {
    var box = event.detail && event.detail.box;
    var root = drawer();
    if (!box || !root || !root.contains(box)) return;
    rankRecs(box);
    syncGift(box);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var up = target.closest('[data-whiff-upgrade]');
    if (up) { event.preventDefault(); upgrade(up); return; }
    var open = target.closest('[data-whiff-gift-open]');
    if (open) { event.preventDefault(); session(PROMPT_KEY, '1'); openGift(open); return; }
    var close = target.closest('[data-whiff-gift-close]');
    if (close) { event.preventDefault(); closeGift(); return; }
    var choose = target.closest('[data-whiff-gift-choose]');
    if (choose) { event.preventDefault(); chooseGift(choose); return; }
    var sheet = giftSheet();
    if (sheet && !sheet.hidden && target === sheet) closeGift();
    /* Headerin ostoskorikuvake: King avaa paneelin ilman uudelleenrenderointia */
    if (target.closest('[data-source="cart-drawer"]') && giftMode() === 'line' && giftEnabled()) {
      window.setTimeout(function () {
        var root = drawer();
        var cta = root && root.querySelector('[data-whiff-gift-cta]');
        if (cta && !cta.hidden) maybePrompt(root);
      }, 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var sheet = giftSheet();
    if (sheet && !sheet.hidden) {
      event.stopPropagation();
      closeGift();
    }
  }, true);

  /* Ensimmainen tila (jos core laski etupalkin ennen taman tiedoston latausta) */
  function start() {
    previewFlag();
    patchDrawer();
    var root = drawer();
    var box = root && root.querySelector('[data-whiff-cart-offers]');
    if (box && box.dataset.stage) {
      rankRecs(box);
      syncGift(box);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* ---------- 4. Tuoksuständi kaupan päälle ----------
     Tila tulee paneelin Liquidista ([data-whiff-stand], snippets/whiff-cart-drawer.liquid).
     Ehto täyttyy (2 × 5 ml + 1 × 10 ml): ständi lisätään riviksi ominaisuudella _whiff_stand.
     Ehto ei täyty: rivi poistetaan. Määrä pidetään 1:ssä. Hinta 0 € tulee Shopifyn
     automaattisesta alennuksesta; jos Shopify ei alentanut riviä, rivi poistetaan eikä sitä
     lisätä uudelleen samalla korin sisällöllä. Jos asiakas poistaa ständin itse, sitä ei
     lisätä takaisin ennen kuin ehto on välillä lakannut täyttymästä. */
  var STAND_BLOCK = 'whiff_stand_block';
  var STAND_DECLINED = 'whiff_stand_declined';
  var standBusy = false;
  var standRecheck = '';
  function standDone(json) {
    standBusy = false;
    if (!json) return;
    applyCart(json, true);
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }
  function syncStand() {
    var root = drawer();
    var el = root && root.querySelector('[data-whiff-stand]');
    if (!el || standBusy) return;
    var d = el.dataset;
    var ok = d.ok === 'true';
    var key = d.key || '';
    var job = null;
    if (!ok) session(STAND_DECLINED, '');
    if (key && !ok) {
      job = jsonPost(changeUrl(), withSections({ id: key, quantity: 0 }));
    } else if (key && (parseInt(d.qty, 10) || 1) > 1) {
      job = jsonPost(changeUrl(), withSections({ id: key, quantity: 1 }));
    } else if (key && d.paid === 'true') {
      if (standRecheck !== key) {
        /* Tarkistetaan kerran tuoreesta korista ennen poistoa */
        standRecheck = key;
        job = fetch(rootUrl() + '?sections=' + encodeURIComponent(sectionId()), { credentials: 'same-origin' })
          .then(function (response) { return response.json(); })
          .then(function (sections) { return { sections: sections }; });
      } else {
        session(STAND_BLOCK, d.sig);
        job = jsonPost(changeUrl(), withSections({ id: key, quantity: 0 }));
      }
    } else if (!key && ok && d.available === 'true' && session(STAND_BLOCK) !== d.sig && session(STAND_DECLINED) !== '1') {
      job = jsonPost(addUrl(), withSections({ items: [{ id: parseInt(d.variant, 10), quantity: 1, properties: { _whiff_stand: '1' } }] }));
    }
    if (!job) return;
    standBusy = true;
    job.then(standDone).catch(function () { standBusy = false; });
  }
  /* Asiakas poisti ständin itse */
  document.addEventListener('click', function (event) {
    var line = event.target.closest && event.target.closest('[data-whiff-stand-line]');
    if (line && event.target.closest('cart-remove-button')) session(STAND_DECLINED, '1');
  }, true);
  /* Paneelin sisältö vaihtuu jokaisen korimuutoksen jälkeen: tila tarkistetaan silloin */
  var standTimer = null;
  function watchStand() {
    var root = drawer();
    if (!root || root._whiffStandWatch) return;
    root._whiffStandWatch = true;
    new MutationObserver(function () {
      window.clearTimeout(standTimer);
      standTimer = window.setTimeout(syncStand, 60);
    }).observe(root, { childList: true, subtree: true });
    syncStand();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchStand);
  else watchStand();

  window.WhiffCart.openGift = openGift;
  window.WhiffCart.adapters = adapters;
  window.WhiffCart.fetchPicker = fetchPicker;
})();